export class CharterPricingLookup {
  search: string = null;
  skip = 0;
  limit = 15;
  active: boolean = null;
  startDate: Date = null;
  endDate: Date = null;
  vendorId = '44343627-025a-4ee3-80cb-218a17b67819';
}
